import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, User } from 'lucide-react';
import { useAuthContext } from '../../auth';

export function AdminHeader() {
  const navigate = useNavigate();
  const { user, logout } = useAuthContext();

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      await logout();
      navigate('/admin/login');
    }
  };

  return (
    <header className="sticky top-0 z-30 flex items-center justify-between h-16 px-4 bg-white border-b border-gray-200">
      <div className="flex items-center">
        <h1 className="text-xl font-bold text-gray-900">Admin Panel</h1>
      </div>

      <div className="flex items-center space-x-4">
        <div className="flex items-center text-sm text-gray-700">
          <User className="w-4 h-4 mr-2" />
          {user?.email}
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center px-4 py-2 text-sm font-medium text-red-600 transition-colors rounded-md hover:bg-red-50"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Logout
        </button>
      </div>
    </header>
  );
}